import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

/**
 * Guard hook for stats sub-pages. Redirects to /statistiques if the
 * current user does not have access to `permKey` (unless admin).
 *
 * Usage inside a stats sub-page component:
 *   useStatsBlockGuard('stats_leaderboard');
 */
export function useStatsBlockGuard(permKey) {
    const { user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!user) return;
        if (user.role === 'admin') return;
        const allowed = user.permissions?.stats_blocks?.[permKey] !== false;
        if (!allowed) {
            toast.error("Accès refusé : cette statistique n'est pas autorisée pour votre compte.");
            navigate('/statistiques', { replace: true });
        }
    }, [user, permKey, navigate]);
}
